import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from "@angular/forms";
import { FieldModel } from "@cv-invision/cv.invision-views.ux";
import { DialogService } from "primeng/dynamicdialog";
import { Subject, takeUntil } from "rxjs";
import { CreateEditFieldValueComponent } from "../components/create-edit-field-value/create-edit-field-value.component";
import { GenericFormService } from "../service/generic-form.service";

@Component({
	selector: 'cv-table-field',
	templateUrl: './table-field.component.html',
	styleUrls: ['./table-field.component.scss'],
})
export class TableFieldComponent implements OnInit, OnDestroy {

	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;

	data: any;
	get emptyColspan(): number {
		const config = this.field.UIOptions?.tableConfig;
		return 2
			+ (config?.hasCounterInfo ? 1 : 0)
			+ (!this.control.disabled && config?.isReorderable ? 1 : 0);
	}

	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private dialogService: DialogService,
		private genericFormService: GenericFormService
	) {
		this.data = []
	}

	ngOnInit(): void {
		if (this.control.value && this.control.value.length > 0) {
			this.data = this.control.value;
		}

		this.control.valueChanges
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((val) => {
				this.data = val;
			});
	}

	displayValue(row: any): string {
		const field = this.field.UIOptions?.tableConfig?.displayField;
		return field ? row?.[field] ?? row : row;
	}

	/**
	 * event to update data after reorder elements
	 * @param $event
	 */
	updateData($event: any): void {
		this.control.setValue(this.data);
	}

	/**
	 * event to remove element from array of data
	 * @param index
	 */
	removeElement(index: number, rowData: any): void {
		this.data = this.data.filter((item) => JSON.stringify(item) !== JSON.stringify(rowData));
		this.updateData(this.data);
		this.genericFormService.onTableFieldChange$.next(
			{
				field: this.field,
				event: this.data
			}
		);
	}

	/**
	 * event to open dialog to create option
	 */
	showNewItemDialog(): void {
		this.dialogService.open(CreateEditFieldValueComponent, {
			header: 'Add ' + this.field.DisplayText,
			width: '21.3rem',
			closeOnEscape: false,
			dismissableMask: false,
			styleClass: 'add-config-type-modal',
			draggable: false
		}).onClose
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((result) => {
				if (result && result.data) {
					this.data.push(result.data.label);
					this.updateData(this.data);
				}
			});
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

}
